const root = '/images/course-sections';

export const sectionArtwork = {
  audience: { src: `${root}/audience-workspace-v1.webp`, alt: 'Ноутбук, блокнот с эскизами и карандаши на рабочем столе', width: 1200, height: 1200 },
  ai: { src: `${root}/ai-workflow-v1.webp`, alt: 'Схема работы с ИИ: чат, сайт, память и подключённые инструменты', width: 1200, height: 800 },
  developer: { src: `${root}/developer-workflow-v1.webp`, alt: 'Код на ноутбуке, макеты сайта и мобильной страницы', width: 1200, height: 800 },
  creative: { src: `${root}/creative-workflow-v1.webp`, alt: 'Рабочие материалы: композиция, макет сайта и монтажная дорожка', width: 1200, height: 800 },
  lessons: { src: `${root}/watch-lessons-v1.webp`, alt: 'Ноутбук с видеоплеером, наушники и блокнот', width: 1200, height: 800 },
  practice: { src: `${root}/practice-tasks-v1.webp`, alt: 'Практическое задание: эскизы в блокноте и список выполненных шагов', width: 1200, height: 800 },
  questions: { src: `${root}/ask-questions-v1.webp`, alt: 'Переписка с вопросом и ответом на экране телефона', width: 1200, height: 800 }
};

export const projectVisuals = {
  'https://dmitrii-fokeev-portfolio.vercel.app/': {
    src: `${root}/project-portfolio-v1.webp`, mobile: `${root}/project-portfolio-mobile-v1.webp`, alt: 'Первый экран сайта-портфолио Дмитрия Фокеева', caption: 'Скриншот проекта', action: 'Открыть сайт'
  },
  'https://t.me/Publisher_Fokeev_Bot': {
    src: `${root}/project-telegram-v1.webp`, alt: 'Учебный SMM-бот Publisher Fokeev в Telegram', caption: 'Кадр из демонстрации', action: 'Открыть бота'
  },
  'https://garage24-ai-assistant.onrender.com/': {
    src: `${root}/project-assistant-v1.webp`, alt: 'ИИ-ассистент отвечает на вопрос о записи в автосервис', caption: 'Кадр из демонстрации', action: 'Смотреть демонстрацию', href: '/videos/ai-development-home-v1.mp4#t=45'
  }
};
